import React from "react";
import { useSchema } from "../../contexts/schema.context";
import { SchemaBlock } from "../../../services/schema/types/schema.types";

/**
 * SchemaInjector organism component that renders Schema.org structured data
 * as JSON-LD script elements in the DOM
 */
export const SchemaInjector: React.FC = () => {
  const { schemas } = useSchema();

  if (!schemas || schemas.length === 0) {
    return null;
  }

  return (
    <>
      {schemas.map((schema: SchemaBlock, index: number) => (
        <script
          key={`schema-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
};
